import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';

export const WorkbookLineageUpstreamDataQualityWarningsQueryGql: DocumentNode = gql`
query WorkbookLineageUpstreamDataQualityWarningsQuery($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $publishedConnectionsLineageEnabled: Boolean!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamDataQualityWarningsConnection (filter: {isActive: true},
                                           first: $first, offset: $offset,
                                           orderBy: {field: IS_SEVERE, direction: DESC}) {
      totalCount
      nodes {
        ...DataQualityWarningFragment
        ...DataQualityWarningAssetFragment
      }
    }
  }
}
${DataQualityWarningFragmentGql}
${DataQualityWarningAssetFragmentGql}
`;
